import { Link } from 'react-router-dom';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from '@azure/msal-react';
import { Button } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { useProperties } from '@providers';
import { languages } from '@i18n';
import {
  countryCodeFromCulture,
  extractFilter,
  headerStickyPoint,
  loginRequest,
  makeUnicodeFlagEmoji,
} from '@utils';
import { MobileMenu } from '../MobileMenu';
import { MobileMenuToggle } from '../MobileMenuToggle';
import './Header.scss';
import { SiteLogoLink } from '../SiteLogo';
import { useTranslation } from 'react-i18next';

export const Header = () => {
  const { t } = useTranslation();

  const { properties, culture, setCulture } = useProperties();
  const msalContext = useMsal();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scroll, setScroll] = useState(0);

  // Track window scroll position
  useEffect(() => {
    const handleScroll = () => setScroll(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const country = countryCodeFromCulture(culture);
  const aims = extractFilter('aim', properties).sort(
    (a, b) => b.count - a.count,
  );

  const handleLogin = () => {
    msalContext.instance.loginRedirect(loginRequest).catch((error) => {
      console.log(error);
    });
  };

  const handleLogout = () => {
    msalContext.instance
      .logoutRedirect({
        postLogoutRedirectUri: '/',
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <header className='ltn__header-area gradient-color-2'>
        <div
          className={`ltn__header-middle-area ltn__header-sticky ltn__sticky-bg-black ${scroll >= headerStickyPoint ? 'sticky-active' : ''}`}
        >
          <div className='container'>
            <div className='row'>
              <div className='col'>
                <div className='site-logo-wrap'>
                  <SiteLogoLink />
                </div>
              </div>
              <div className='col d-none d-xl-block'>
                <nav>
                  <div className='ltn__main-menu'>
                    <ul>
                      <li>
                        <Link to='/'>{t('header.home')}</Link>
                      </li>
                      <li className='menu-icon'>
                        <Link to='/properties'>{t('header.properties')}</Link>
                        <ul>
                          <li>
                            <Link to='/properties'>
                              {t('header.allProperties')}
                            </Link>
                          </li>
                          {aims.map(({ text }) => (
                            <li key={text}>
                              <Link to={`/properties?aim=${text}`}>{text}</Link>
                            </li>
                          ))}
                          <li>
                            <Link to='/wishlist'>{t('header.wishlist')}</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to='/add-listing'>{t('header.addListing')}</Link>
                      </li>
                      <li>
                        <Link to='/request-property'>
                          {t('header.request')}
                        </Link>
                      </li>
                      <li>
                        <Link to='/about'>{t('header.about')}</Link>
                      </li>
                      <li>
                        <Link to='/contact'>{t('header.contact')}</Link>
                      </li>
                      <AuthenticatedTemplate>
                        <li>
                          <a>
                            <i className='flaticon-user user-menu-btn logged-in'></i>
                          </a>
                          <ul>
                            {/*<li>*/}
                            {/*  <ToggleButton*/}
                            {/*    id='admin-mode-toggle'*/}
                            {/*    checked={false}*/}
                            {/*    className='theme-btn-1 btn-effect-1 text-uppercase'*/}
                            {/*    size='sm'*/}
                            {/*    type='checkbox'*/}
                            {/*    variant='outline-secondary'*/}
                            {/*    value='0'*/}
                            {/*  >*/}
                            {/*    {t('header.adminControls')}*/}
                            {/*  </ToggleButton>*/}
                            {/*</li>*/}
                            <li>
                              <Link to='/admin/messages'>
                                {t('header.adminMessages')}
                              </Link>
                            </li>
                            <li>
                              <Button
                                className='theme-btn-1 btn-effect-1 text-uppercase'
                                size='sm'
                                onClick={handleLogout}
                              >
                                {t('header.logout')}
                              </Button>
                            </li>
                          </ul>
                        </li>
                      </AuthenticatedTemplate>
                      <UnauthenticatedTemplate>
                        <li>
                          <a>
                            <i className='flaticon-user user-menu-btn'></i>
                          </a>
                          <ul>
                            <li>
                              <Button
                                className='theme-btn-1 btn-effect-1 text-uppercase'
                                size='sm'
                                onClick={handleLogin}
                              >
                                {t('footer.signIn')}
                              </Button>
                            </li>
                          </ul>
                        </li>
                      </UnauthenticatedTemplate>
                      <li>
                        <a className='language-btn text-uppercase'>
                          <span className='round-icon'>
                            {makeUnicodeFlagEmoji(country)}
                          </span>
                          {culture}
                        </a>
                        <ul>
                          {languages.map(({ code }) => (
                            <li key={code}>
                              <a
                                className='language-btn text-uppercase'
                                onClick={() => setCulture(code)}
                              >
                                <span className='round-icon'>
                                  {makeUnicodeFlagEmoji(
                                    countryCodeFromCulture(code),
                                  )}
                                </span>
                                {code}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
              <div className='ltn__header-options'>
                <MobileMenuToggle
                  isMenuOpen={isMenuOpen}
                  setIsMenuOpen={setIsMenuOpen}
                />
              </div>
            </div>
          </div>
        </div>
      </header>
      <MobileMenu
        isOpen={isMenuOpen}
        handleClose={() => setIsMenuOpen(false)}
      />
      <div
        className='ltn__utilize-overlay'
        style={{ display: isMenuOpen ? 'block' : 'none' }}
        onClick={() => setIsMenuOpen(false)}
      ></div>
    </>
  );
};
